import React from 'react';
import { Briefcase, DollarSign } from 'lucide-react';

/**
 * Компонент для выбора активов для сравнения с инфляцией
 */
const BenchmarkComparisonSection = ({ 
  formData, 
  handleInputChange, 
  errors,
  benchmarkAssets 
}) => {
  // Обработчик изменения чекбоксов активов
  const handleBenchmarkChange = (assetId) => {
    const currentBenchmarks = [...formData.benchmarks];
    const assetIndex = currentBenchmarks.indexOf(assetId);
    
    if (assetIndex === -1) {
      // Добавляем актив в список
      currentBenchmarks.push(assetId);
    } else {
      // Удаляем актив из списка
      currentBenchmarks.splice(assetIndex, 1);
    }
    
    // Обновляем состояние формы
    handleInputChange({
      target: {
        name: 'benchmarks',
        value: currentBenchmarks
      }
    });
  };
  
  return (
    <div className="mb-6 bg-green-50 dark:bg-green-900/20 p-4 rounded-lg border border-green-200 dark:border-green-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Briefcase className="w-5 h-5 mr-2 text-green-600 dark:text-green-400" />
        Сравнение с инвестиционными активами
      </h3>
      
      <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
        Выберите активы для сравнения с инфляцией, чтобы увидеть как изменилась бы стоимость, если бы средства были вложены в эти активы.
      </p>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2">
        {benchmarkAssets.map((asset) => (
          <label key={asset.id} className="inline-flex items-center">
            <input
              type="checkbox"
              checked={formData.benchmarks.includes(asset.id)}
              onChange={() => handleBenchmarkChange(asset.id)}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              {asset.name}
            </span>
          </label>
        ))}
      </div>
      
      <div className="mt-4 bg-green-100 dark:bg-green-900/40 p-3 rounded-lg border border-green-200 dark:border-green-800">
        <div className="flex items-start">
          <DollarSign className="w-5 h-5 text-green-600 dark:text-green-400 mr-3 mt-1" />
          <div>
            <h4 className="text-sm font-medium text-green-700 dark:text-green-300 mb-1">
              Особенности сравнения с активами
            </h4>
            <p className="text-xs text-green-600 dark:text-green-400">
              Сравнение основано на исторических данных и не учитывает комиссии, особенности налогообложения и другие 
              дополнительные расходы, связанные с инвестированием в выбранные активы. Результаты приведены для общего представления.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BenchmarkComparisonSection;